import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { FetchJobBoardCandidate, fetchJobBoardCandidate } from 'wisestep-api';

import getDecodedQueryParams from '../../../utils/getDecodedQueryParams';
import { useConversationWidgetStore } from '../../../utils/useConversationWidgetStore';

type ProfileParams = {
  candidateId: string;
  emailId: string;
};

const CandidateProfile = () => {
  const params = useParams<ProfileParams>();
  const [searchParams] = useSearchParams();

  const updateSelectedEmail = useConversationWidgetStore((state) => state.updateSelectedEmail);
  const updateId = useConversationWidgetStore((state) => state.updateId);
  const setCloseTab = useConversationWidgetStore((state) => state.setCloseTab);
  const setSearchQuery = useConversationWidgetStore((state) => state.setSearchQuery);
  const setIsNativeSearch = useConversationWidgetStore((state) => state.setIsNativeSearch);
  const setIsLatest = useConversationWidgetStore((state) => state.setIsLatest);
  const getLatest = useConversationWidgetStore((state) => state.getLatest);
  const setResumeUpdatedOn = useConversationWidgetStore((state) => state.setResumeUpdatedOn);
  const q = searchParams.get('q');
  const queryParam = searchParams.get('query');
  const sessionQuery = queryParam ? sessionStorage.getItem(queryParam) : null;
  const localStorageQuery = queryParam ? localStorage.getItem(queryParam) : null;
  let queryParams = null;
  if (q) {
    const sessionParam = sessionStorage.getItem(q);
    const localStorageParam = localStorage.getItem(q);
    if (sessionParam != null) {
      queryParams = getDecodedQueryParams(sessionParam);
    } else if (localStorageParam != null) {
      queryParams = getDecodedQueryParams(localStorageParam);
      sessionStorage.setItem(q, localStorageParam);
      localStorage.removeItem(q);
    }
  }
  useEffect(() => {
    const jobBoardId = searchParams.get('jobBoardId') ?? queryParams?.['jobBoardId'] ?? '';
    const candidateData = localStorage.getItem(jobBoardId);
    if (candidateData) {
      sessionStorage.setItem(jobBoardId, candidateData);
      localStorage.removeItem(jobBoardId);
    }
    setCloseTab(true);
    let queryData: string | null = null;
    if (queryParam) {
      if (sessionQuery != null) {
        queryData = sessionQuery;
      } else if (localStorageQuery != null) {
        queryData = localStorageQuery;
        sessionStorage.setItem(queryParam, localStorageQuery);
        localStorage.removeItem(queryParam);
      }
    }
    setSearchQuery(decodeURI(queryData ?? queryParams?.['query'] ?? ''));
    updateSelectedEmail(params.emailId ?? '');
    updateId(params.candidateId ?? '');
    setIsNativeSearch(true);
    setIsLatest(false);
    setResumeUpdatedOn(
      searchParams.get('resumeUpdatedOn') ?? queryParams?.['resumeUpdatedOn'] ?? ''
    );
  }, [
    localStorageQuery,
    params.candidateId,
    params.emailId,
    queryParam,
    queryParams,
    searchParams,
    sessionQuery,
    setCloseTab,
    setIsLatest,
    setIsNativeSearch,
    setResumeUpdatedOn,
    setSearchQuery,
    updateId,
    updateSelectedEmail,
  ]);
  const candidateData =
    searchParams.get('candidate') ??
    queryParams?.['candidate'] ??
    sessionStorage.getItem(searchParams.get('jobBoardId') ?? queryParams?.['jobBoardId'] ?? '');

  useEffect(() => {
    const reqObj: FetchJobBoardCandidate = {
      jobBoardAccountId: searchParams.get('accountId') ?? queryParams?.['accountId'] ?? '',
      jobBoardId: searchParams.get('jobBoardId') ?? queryParams?.['jobBoardId'] ?? '',
      force: true,
      harvestingId: '',
      searchType: searchParams.get('searchType') ?? queryParams?.['searchType'] ?? '',
    };
    if (candidateData) {
      reqObj.candidateData = getDecodedQueryParams(candidateData);
    }
    const getLatestCv = async () => {
      try {
        await fetchJobBoardCandidate(reqObj);
        window.location.reload();
      } catch {
        window.location.reload();
      }
    };
    if (getLatest) getLatestCv();
  }, [candidateData, getLatest, queryParams, searchParams]);

  return <></>;
};
export default CandidateProfile;
